import { Skeleton } from 'antd';
import type { FC } from 'react';

const COMMENT_COUNT = 3;

const CommentSkeleton: FC = () => {
  return (
    <div style={{ padding: '12px 0', borderBottom: '1px solid #f0f0f0' }}>
      <Skeleton
        active
        avatar={{ size: 'small' }}
        paragraph={{ rows: 1, width: '80%' }}
        title={{ width: 200 }}
      />
    </div>
  );
};

export const CommentListSkeleton: FC = () => {
  return (
    <div>
      <Skeleton.Input
        active
        size="small"
        style={{ width: 100, height: 16, marginTop: 12, marginBottom: 4 }}
      />
      {Array.from({ length: COMMENT_COUNT }, (_, i) => (
        // biome-ignore lint/suspicious/noArrayIndexKey: static skeleton placeholder
        <CommentSkeleton key={i} />
      ))}
    </div>
  );
};
